import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { type OnboardingPage } from '../routes'
import { PricingMREAcheelCoversSection } from '../components/PricingMREAcheelCoversSection'
import { PricingMREAcheelPackageSection } from '../components/PricingMREAcheelPackageSection'
import { OnboardingTitle } from '../components/OnboardingTitle'
import { OnboardingNextButton } from '../components/OnboardingNextButton'
import { useOnboardingWorkflow } from '../workflow'
import { PricingCard } from '../components/PricingCard'
import { FormattedPrice } from '../components/FormattedPrice'
import { track } from '../../utils/analytics'
import { PricingMREAcheelCoversOptions } from '../components/PricingMREAcheelCoversOptions'
import { useQuotation } from '../context'
import { Card, CardContent } from '@olino/design-system'
import { PricingMREAcheelDeductibleSlider } from '../components/PricingMREAcheelDeductibleSlider'

const Main = () => {
  const { id } = useParams()
  const { proceed } = useOnboardingWorkflow()
  const { quotation, updateQuotation } = useQuotation()

  const onProceed = () => {
    track({
      event: 'submitted_pricing_page',
      quotation_id: id,
    })

    proceed()
  }
  let count = 0
  if (quotation.covers?.mreAcheel !== undefined && quotation.covers.mreAcheel !== null) {
    count = Object.values(quotation.covers?.mreAcheel).filter((val) => val != null).length
  }

  useEffect(() => {
    track({
      event: 'visited_pricing_page',
      quotation_id: id,
    })
  }, [id])

  return (
    <>
      <OnboardingTitle.H1>Votre devis pour votre multirisque professionnelle</OnboardingTitle.H1>

      <div className="space-y-14">
        <div className="block lg:hidden">
          <PricingCard>
            <PricingMREAcheelCoversSection />
          </PricingCard>
        </div>

        <PricingMREAcheelPackageSection />

        <Card>
          <CardContent className="space-y-8">
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <OnboardingTitle.H2Pricing>Protections essentielles</OnboardingTitle.H2Pricing>
                <span className="text-xs md:text-sm">
                  Ce sont les protections minimales dont vous ne pouvez vous passer.
                </span>
              </div>

              <div className="space-y-3">
                <FormattedPrice
                  size="sm"
                  originalAmount={quotation.premium?.mreAcheel?.originalTotal}
                  paymentFrequency={quotation.details.paymentFrequency}
                  hideLoader
                />
              </div>
            </div>

            <PricingMREAcheelDeductibleSlider />

            <div className="space-y-3">
              <p>
                Nous incluons {count} garanties essentielles pour protéger au mieux votre entreprise
                :
              </p>
              <PricingMREAcheelCoversOptions displayOnlyCover />
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-col gap-8">
          {/*<PricingMREAcheelOptionsSection />*/}

          <div className="flex justify-end">
            <OnboardingNextButton onClick={() => onProceed()}>
              Souscrire
              <FontAwesomeIcon icon={faArrowRight} />
            </OnboardingNextButton>
          </div>
        </div>
      </div>
    </>
  )
}

const Tips = () => {
  return (
    <div className="hidden lg:block">
      <PricingCard showQuote={false} showEntreeRel={true}>
        <PricingMREAcheelCoversSection />
      </PricingCard>
    </div>
  )
}

export default {
  main: <Main />,
  tips: <Tips />,
} satisfies OnboardingPage
